import React from 'react'
import { format } from 'date-fns'

const GeographicAreas = ({ appraiserInfo }) =>
  <div className='geographic-areas usa-width-one-whole'>
    <h3>Geographic Areas</h3>
    <table>
      <thead>
        <tr>
          <th>State</th>
          <th>County</th>
          <th>City</th>
          <th>Last Assignment Date</th>
        </tr>
      </thead>
      <tbody>
        {appraiserInfo.fetching && <tr><td colSpan='4'>Loading...</td></tr>}
        {appraiserInfo.error && !appraiserInfo.fetching && <tr><td colSpan='4'>Error: Unable to load geographic areas.</td></tr>}
        {appraiserInfo && !appraiserInfo.error && !appraiserInfo.fetching
          && (appraiserInfo.assignedGeoAreas.length < 1 ?
            <tr><td colSpan='4'>No geographic areas have been defined.</td></tr>
            : appraiserInfo.assignedGeoAreas.map(area =>
              <tr key={area.stateCode + area.cityName + area.countyName}>
                <td>{area.stateCode}</td>
                <td>{area.countyName}</td>
                <td>{area.cityName}</td>
                <td>{format(area.lastAssignmentDate, 'MM/dd/yyyy', { awareOfUnicodeTokens: true })}</td>
              </tr>))}
      </tbody>
    </table>
  </div>

export default GeographicAreas
